import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Create,
  CreateProps,
  ListButton,
  SaveButton,
  SimpleForm,
  TextInput,
  Toolbar,
  ToolbarProps,
  useTranslate,
} from 'react-admin'
import { TSCanDto } from '../../../core/dto/device/ts-cans/ts-can.dto'

const validateTSCanCreate = (values: TSCanDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.name) {
    errors.name = 'ra.validation.required'
  }
  if (!values.address) {
    errors.address = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.ts-cans.titles.create')}</span>
}

const CreateToolbar = (props: ToolbarProps) => (
  <Toolbar {...props}>
    <SaveButton />
    <ListButton icon={<Cancel />} label="const.cancel" />
  </Toolbar>
)

export const TSCanCreate = (props: CreateProps) => (
  <Create {...props} title={<CreateTitle />}>
    <SimpleForm
      redirect="show"
      validate={validateTSCanCreate}
      toolbar={<CreateToolbar />}
    >
      <TextInput source="name" isRequired />
      <TextInput source="address" isRequired />
    </SimpleForm>
  </Create>
)
